export const SIZES = {
  XS: 'xs',
  MD: 'md',
  SM: 'sm'
};